import XLSX from 'xlsx';
import FileSaver from 'file-saver';

export default {
  data() {
    return {
      // 辅导员姓名
      name: '',
      // 辅导员手机号
      phone: '',
      // 处理后的数组
      list: [],
      // 数据总条数
      total: 0,
      // 每页显示条数
      pageSize: 15,
      // 当前页
      currPage: 1
    }
  },

  methods: {

    // 确认搜索
    confirmSearch() {
      
        this.$post('instructor/workload_statistics', {
          token: this.$store.state.authority_management,
          name: this.name,
          phone: this.phone,
          offset: 0,
          length: this.pageSize
        }).then(res => {
          let list = res.data.result.data
          this.total = res.data.result.total
		  this.currentPage = 1
          this.handleList(list)
        })
      
    },

    // 获取数据
    getData() {
      this.$post('instructor/workload_statistics', {
        token: this.$store.state.authority_management,
        name: this.name,
        phone: this.phone,
        offset: (this.currPage - 1) * this.pageSize,
        length: this.pageSize
      }).then(res => {
        let list = res.data.result.data
        this.total = res.data.result.total
        this.handleList(list)
      })
    },

    // 处理数组，计算出需要显示的数据
    handleList(list) {
      let newList = []

      list.map(item => {
        let obj = {}
        obj.id = item.id
        obj.name = item.name
        obj.phone = item.phone
        obj.studentNum = 0
        obj.scoreNum = 0

        if (item.class.length > 0) {
          // 学员数量
          obj.studentNum = item.class.length

          // 获取已评价的课程作业数量
          item.class.map(item2 => {

            // 如果该学员的rate不等于空才进行计算
            if (item2.rate) {

              let rate = JSON.parse(item2.rate)
              rate.map(task => {
                task.task_activities.map(task_activitie => {
                  task_activitie.resources.map(resource => {
                    resource.items.map(item => {

                      // 当前的是课程作业
                      if (task_activitie.name == 'class' && item.type == 7) {

                        // 如果有分数，则已评价的课程作业数量加1
                        if (item.grade) {
                          obj.scoreNum = obj.scoreNum * 1 + 1
                        }
                      }
                    })
                  })
                })
              })
            }
          })
        }
        newList.push(obj)
      })
      this.list = newList
      return newList
    },

    // 导出表格
    exportToExcel() {
      this.$post('instructor/workload_statistics', {
        token: this.$store.state.authority_management,
        offset: 0,
        length: 999999
      }).then(res => {
        const list = this.handleList(res.data.result.data)
        this.list = list
        let wb = XLSX.utils.table_to_book(document.getElementById('exportXlsx'))

        let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
        try {
          FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'test.xlsx')
        } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
        return wbout
      })

    
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getData()
    },

    handleCurrentChange(currPage) {
      this.currPage = currPage
      this.getData()
    }

  },

  created() {
    this.getData()
  },
}